import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CommodityCode } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CommodityCodeService extends TmsWebBaseEditService<CommodityCode, CommodityCode> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CommodityCode', $localize`Commodity Code`);
  }
}
